import React from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const ProtectedRoute = ({ children }) => {
    try {
        const token = localStorage.getItem('app_token');

        // If no token exists, the user is not logged in. Redirect to login.
        if (!token) {
            return <Navigate to="/login" />;
        }

        const user = jwtDecode(token);

        // If the user's role is 'admin', allow access to the wrapped component (children).
        if (user.role === 'admin') {
            return children;
        } else {
            // If the user is logged in but not an admin, redirect to the homepage.
            return <Navigate to="/" />;
        }
    } catch (error) {
        // If the token is invalid or expired, redirect to login.
        console.error("Authentication error:", error);
        return <Navigate to="/login" />;
    }
};

const AdminOnlyRoute = ({ children }) => {
    try {
        const token = localStorage.getItem('app_token');

        // If no token exists, the user is not logged in. Redirect to login.
        if (!token) {
            return <Navigate to="/login" />;
        }

        const user = jwtDecode(token);

        // If the user's role is 'admin', allow access to the wrapped component (children).
        if (user.role === 'admin') {
            return children;
        } else {
            // If the user is logged in but not an admin, redirect to the homepage.
            return <Navigate to="/" />;
        }
    } catch (error) {
        // If the token is invalid or expired, redirect to login.
        console.error("Authentication error:", error);
        return <Navigate to="/login" />;
    }
};

export { ProtectedRoute, AdminOnlyRoute };
